import { FilterState } from '@/app/(main)/(pages)/busca/[slug]/_types/filter-state.type';
import { DISTANCE_ANALYTICS_KEY } from '@/app/(main)/(pages)/busca/[slug]/_types/search-sort.type';
import { AGE_GROUP_ANALYTICS_KEY } from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-age-group.type';
import { DAY_TIME_ANALYTICS_KEY } from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-day-time.type';
import { DATE_ANALYTICS_KEY } from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-date.type';
import { PROFESSIONAL_GENDER_ANALYTICS_KEY } from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-professional-gender.type';
import {
  FOLLOW_UP_ANALYTICS_KEY,
  ONLY_SCHEDULED_ANALYTICS_KEY,
} from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-booking-preference.type';
import { initialFilterState } from '@/app/(main)/(pages)/busca/[slug]/_consts/search-filter.consts';
import {
  AvailableSearchFilters,
  getAvailableFilters,
} from '@/app/(main)/(pages)/busca/[slug]/_utils/filter-availability.util';
import { SearchType } from '@/types/most-search-type';

const FILTER_ANALYTICS_KEYS: ReadonlyArray<[keyof AvailableSearchFilters, string]> = [
  ['distance', DISTANCE_ANALYTICS_KEY],
  ['ageGroup', AGE_GROUP_ANALYTICS_KEY],
  ['dayTime', DAY_TIME_ANALYTICS_KEY],
  ['minDate', DATE_ANALYTICS_KEY],
  ['professionalGender', PROFESSIONAL_GENDER_ANALYTICS_KEY],
  ['followUp', FOLLOW_UP_ANALYTICS_KEY],
  ['onlyScheduled', ONLY_SCHEDULED_ANALYTICS_KEY],
];

export function getActiveFilters(filters: FilterState, modality: SearchType): string[] {
  const available = getAvailableFilters(filters, modality);

  return FILTER_ANALYTICS_KEYS
    .filter(([key]) => available[key] !== undefined && available[key] !== initialFilterState[key])
    .map(([, analyticsKey]) => analyticsKey);
}
